import { useStore } from "@/store";
import {
  AlertDialog,
  AlertDialogAction,
  AlertDialogCancel,
  AlertDialogContent,
  AlertDialogDescription,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogTitle,
} from "@/components/ui/alert-dialog";

export interface DialogType {
  onConfirm: () => Promise<void>;
  title: string;
  message: string;
  confirmText: string;
  time?: Date;
}

export function DialogRegistry(): React.JSX.Element {
  const { dialogs, closeDialog } = useStore((s) => s);

  async function handleConfirmClick(dialog: DialogType) {
    await dialog.onConfirm();
    if (dialog.time) {
      closeDialog(dialog.time);
    }
  }

  if (!dialogs.length) return <></>;

  return (
    <>
      {dialogs.map((dialog) => {
        const key = dialog.time ? dialog.time.getTime() : Math.random();
        return (
          <AlertDialog open={true} key={key}>
            <AlertDialogContent>
              <AlertDialogHeader>
                <AlertDialogTitle>{dialog.title}</AlertDialogTitle>
                <AlertDialogDescription>{dialog.message}</AlertDialogDescription>
              </AlertDialogHeader>
              <AlertDialogFooter>
                <AlertDialogCancel
                  onClick={() => {
                    if (dialog.time) {
                      closeDialog(dialog.time);
                    }
                  }}
                >
                  Uždaryti
                </AlertDialogCancel>
                <AlertDialogAction onClick={() => handleConfirmClick(dialog)}>
                  {dialog.confirmText}
                </AlertDialogAction>
              </AlertDialogFooter>
            </AlertDialogContent>
          </AlertDialog>
        );
      })}
    </>
  );
}
